import React, { Fragment, useEffect, useRef, useState } from "react";
import axios from "axios";
import CrearSolicitud from "../modals/CreaSolicitud";
import {
  estadoParametros,
  estadoParametrosUser,
  ObtenerSolicitudes,
  obtenerSolicitudesEstado,
  ObtenerSolicitudesPorId,
  obtenerSolicitudesPorRegional,
} from "../Services/Rest";
import Cookies from "universal-cookie";
import Consolidado from "./Consolidado";
import { DownloadTableExcel } from "react-export-table-to-excel";
import * as XLSX from "xlsx";

const urlA = ObtenerSolicitudes;
const urlG = obtenerSolicitudesPorRegional;
const urlC = ObtenerSolicitudesPorId;
const cookie = new Cookies();

if (cookie.get("tipo_Usuario") == 1) {
  var urlendpoint = urlA;
}
if (cookie.get("tipo_Usuario") == 2) {
  var urlendpoint = urlG + cookie.get("correo");
}
if (cookie.get("tipo_Usuario") == 3) {
  var urlendpoint = urlC + cookie.get("id");
}

const urlAdmin = estadoParametros;
const urlUsuaio = estadoParametrosUser;

if (cookie.get("tipo_Usuario") == 1) {
  var urlendpointEstado = urlAdmin;
}
if (cookie.get("tipo_Usuario") == 2) {
  var urlendpointEstado = urlUsuaio + cookie.get("tipo_Usuario");
}
if (cookie.get("tipo_Usuario") == 3) {
  var urlendpointEstado = urlUsuaio + cookie.get("tipo_Usuario");
}

function SolicitudAdmin(props) {
  const exportToExcel = () => {
    const fileName = "data.xlsx";
    const worksheet = XLSX.utils.json_to_sheet(lis);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, fileName);
  };
  const tableRef = useRef(null);
  const [lis, setLis] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url: "https://educacionapi.azurewebsites.net/api/ObtenerSolicitudes",
    })
      .then((Response) => {
        setLis(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setLis]);

  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url: urlendpointEstado,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const URL = urlendpoint;
  const [search, setSearch] = useState("");
  const searcher = (e) => {
    setSearch(e.target.value);
  };
  const [postEstado, setPostEstado] = useState([]);
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: obtenerSolicitudesEstado + postEstado,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const BusacarPorEstado = () => {
    axios
      .get(obtenerSolicitudesEstado + postEstado)
      .then((response) => {
        setList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlecountry = (event) => {
    const EStadoId = event.target.value;
    setPostEstado(EStadoId);
  };

  const fechaActual = new Date();

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-12">
              <div class="card-header py-12">
                <h6 class="m-0 font-weight-bold text-primary">
                  Información Solicitudes
                </h6>
              </div>
              <div class="card-body">
                <CrearSolicitud />
                <hr />
                <button
                  className="btn btn-Excel btn-user "
                  onClick={exportToExcel}
                >
                  Exportar a Excel
                </button>

                <hr />
                {cookie.get("tipo_Usuario") == 1 ? (
                  <div className="form-group row">
                    <div className="col-sm-6 mb-3 mb-sm-0 ">
                      <select
                        className="btn btn-secondary btn-user btn-block text-left"
                        onChange={(e) => handlecountry(e)}
                      >
                        <option value="">Seleccione el estado </option>
                        {list1.map((getcon, index) => (
                          <option key={index} value={getcon.id}>
                            {getcon.estado}{" "}
                          </option>
                        ))}
                      </select>
                    </div>
                    <hr />
                    <div className="col-sm-6">
                      <button
                        className="btn btn-primary btn-user btn-block"
                        onClick={() => BusacarPorEstado()}
                      >
                        Buscar
                      </button>
                    </div>
                  </div>
                ) : (
                  <h1></h1>
                )}
                <hr />
                {cookie.get("tipo_Usuario") !== 1 ? (
                  <input
                    value={search}
                    onChange={searcher}
                    type="text"
                    placeholder="Buscar por nombre"
                    className="form-control"
                  />
                ) : (
                  <h1></h1>
                )}
                <hr className="sidebar-divider" />
                <div class="table-responsive">
                  <div className="form-group row">
                    <div className="col-sm-6 mb-3 mb-sm-0 "></div>
                  </div>
                  {cookie.get("tipo_Usuario") == 1 ? (
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Nombre cliente</th>
                          <th>Correo Gestor</th>
                          <th>Descripción</th>
                          <th>Detalle Estado</th>
                          <th>Fecha Creación</th>
                          <th>Tipo de Usuario</th>
                          <th>Consultar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item) => {
                          const fecha = new Date(item.fechaCreacion);
                          return (
                            <tr>
                              <td>{item.id}</td>
                              <td>{item.nombreCliente}</td>
                              <td>{item.regional}</td>
                              <td>{item.descripcion}</td>
                              <td>{item.detalleEstado}</td>
                              {(fechaActual.getDate() - fecha.getDate() > 5 &&
                                item.estado !== "Aprobado" &&
                                item.estado !== "Rechazado") ||
                              (fechaActual.getDate() - fecha.getDate() < -5 &&
                                item.estado !== "Aprobado" &&
                                item.estado !== "Rechazado") ? (
                                <td class="text-light bg-danger">
                                  {fecha.toLocaleDateString(
                                    "en-US",
                                    item.fechaCreacion
                                  )}
                                </td>
                              ) : (fechaActual.getDate() - fecha.getDate() >=
                                  3 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ||
                                (fechaActual.getDate() - fecha.getDate() == 0 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ||
                                (fechaActual.getDate() - fecha.getDate() == 1 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ||
                                (fechaActual.getDate() - fecha.getDate() == 2 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ||
                                (fechaActual.getDate() - fecha.getDate() == 3 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ? (
                                <td class="text-light bg-warning">
                                  {fecha.toLocaleDateString(
                                    "en-US",
                                    item.fechaCreacion
                                  )}
                                </td>
                              ) : (
                                <td class="text">
                                  {fecha.toLocaleDateString(
                                    "en-US",
                                    item.fechaCreacion
                                  )}
                                </td>
                              )}
                              {item.tipoUsuario == 1 ? (
                                <td>{"Administrador"}</td>
                              ) : item.tipoUsuario == 2 ? (
                                <td>{"Gestor"}</td>
                              ) : (
                                <td>{"Comercial"}</td>
                              )}
                              <td>
                                <Consolidado
                                  id={item.id}
                                  regional={item.regional}
                                  descripcion={item.descripcion}
                                  estado={item.estado}
                                  fechaCreacion={fecha.toLocaleDateString(
                                    "en-US",
                                    item.fechaCreacion
                                  )}
                                  nombreCliente={item.nombreCliente}
                                  adjunto1={item.adjunto}
                                  adjunto2={item.adjunto2}
                                  usuarioId={item.usuarioId}
                                  userIdAsignacion={item.userIdAsignacion}
                                  clasificacionComercial={
                                    item.clasificacionComercial
                                  }
                                  modalidad={item.modalidad}
                                  modular={item.modular}
                                  nombreCapacitacion={item.nombreCapacitacion}
                                  duracion={item.duracion}
                                  numeroParticipantes={item.numeroParticipantes}
                                  entregables={item.entregables}
                                  otrosRequerimientos={item.otrosRequerimientos}
                                  campoObservacion={item.campoObservacion}
                                  regionalAsignado={item.regionalAsignado}
                                  usuarioAsignado={item.nombreUsuario}
                                  detalleEstado={item.detalleEstado}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <h1></h1>
                  )}
                  <div className="pagination-background"></div>
                </div>

                <div class="table-responsive" hidden>
                  <div className="form-group row">
                    <div className="col-sm-6 mb-3 mb-sm-0 "></div>
                  </div>
                  {cookie.get("tipo_Usuario") == 1 ? (
                    <table ref={tableRef}>
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Nombre cliente</th>
                          <th>Correo Gestor</th>
                          <th>Descripción</th>
                          <th>Estado</th>
                          <th>Detalle Estado</th>
                          <th>Fecha Creación</th>
                          <th>Tipo de Usuario</th>
                          <th>Nombre Cliente</th>
                          <th>Adjunto</th>
                          <th>Clasificación Comercial</th>
                          <th>Modalidad</th>
                          <th>Modular</th>
                          <th>Nombre Capacitacion</th>
                          <th>Duracion</th>
                          <th>Numero Participantes</th>
                          <th>Entregables</th>
                          <th>Otros Requerimientos</th>
                          <th>Campo Observacion</th>
                          <th>Nombre Usuario</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lis.map((item) => {
                          const fecha = new Date(item.fechaCreacion);
                          return (
                            <tr>
                              <td>{item.id}</td>
                              <td>{item.nombreCliente}</td>
                              <td>{item.regional}</td>
                              <td>{item.descripcion}</td>
                              <td>{item.estado}</td>
                              <td>{item.detalleEstado}</td>
                              {(fechaActual.getDate() - fecha.getDate() > 5 &&
                                item.estado !== "Aprobado" &&
                                item.estado !== "Rechazado") ||
                              (fechaActual.getDate() - fecha.getDate() < -5 &&
                                item.estado !== "Aprobado" &&
                                item.estado !== "Rechazado") ? (
                                <td class="text-light bg-danger">
                                  {fecha.toLocaleDateString(
                                    "en-US",
                                    item.fechaCreacion
                                  )}
                                </td>
                              ) : (fechaActual.getDate() - fecha.getDate() >=
                                  3 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ||
                                (fechaActual.getDate() - fecha.getDate() == 0 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ||
                                (fechaActual.getDate() - fecha.getDate() == 1 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ||
                                (fechaActual.getDate() - fecha.getDate() == 2 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ||
                                (fechaActual.getDate() - fecha.getDate() == 3 &&
                                  item.estado !== "Aprobado" &&
                                  item.estado !== "Rechazado") ? (
                                <td class="text-light bg-warning">
                                  {fecha.toLocaleDateString(
                                    "en-US",
                                    item.fechaCreacion
                                  )}
                                </td>
                              ) : (
                                <td class="text">
                                  {fecha.toLocaleDateString(
                                    "en-US",
                                    item.fechaCreacion
                                  )}
                                </td>
                              )}
                              {item.tipoUsuario == 1 ? (
                                <td>{"Administrador"}</td>
                              ) : item.tipoUsuario == 2 ? (
                                <td>{"Gestor"}</td>
                              ) : (
                                <td>{"Comercial"}</td>
                              )}
                              <td>{item.nombreCliente}</td>
                              <td>{item.adjunto}</td>
                              <td>{item.clasificacionComercial}</td>
                              <td>{item.modalidad}</td>
                              <td>{item.modular}</td>
                              <td>{item.nombreCapacitacion}</td>
                              <td>{item.duracion}</td>
                              <td>{item.numeroParticipantes}</td>
                              <td>{item.entregables}</td>
                              <td>{item.otrosRequerimientos}</td>
                              <td>{item.campoObservacion}</td>
                              <td>{item.nombreUsuario}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <h1></h1>
                  )}

                  <div className="pagination-background"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default SolicitudAdmin;
